import { Reducer } from "redux";

import { NtuReasonMasterResponse } from "../models/api/Referral";
import { NtuReasonMasterDispatchTypes } from "../models/dispatchTypes/Referral";
import { NtuReasonMasterActionDispatchTypes } from "../constants/HomePage";

export const initialState: NtuReasonMasterResponse = {
  loading: false,
  response: [],
};

const MasterNtuReasonReducer: Reducer<
  NtuReasonMasterResponse,
  NtuReasonMasterDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case NtuReasonMasterActionDispatchTypes.GET_NTU_REASON_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case NtuReasonMasterActionDispatchTypes.GET_NTU_REASON_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case NtuReasonMasterActionDispatchTypes.GET_NTU_REASON_ERROR: {
      return initialState;
    }
  }
  return state;
};

export default MasterNtuReasonReducer;
